import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class LandingPageController extends AuthenticatedController {
  static getAll(botId) {
    return super.get(APIRoutes.LANDING_PAGES(botId));
  }

  static getById(botId, landingPageId) {
    return super.get(`${APIRoutes.LANDING_PAGES(botId)}/${landingPageId}`);
  }

  static async post(botId, entity, fbPageId) {
    // I'm adding an extra paramater that is not part of the model separately.
    const mappedEntityPlusFbPageId = Object.assign({}, entity, {
      facebook_page_id: fbPageId,
    });
    const response = await super.post(
      APIRoutes.LANDING_PAGES(botId),
      mappedEntityPlusFbPageId,
    );
    return response.landingPage;
  }

  static async put(botId, entity) {
    const response = await super.put(
      `${APIRoutes.LANDING_PAGES(botId)}/${entity.id}`,
      entity,
    );
    return response.landingPage;
  }

  static delete(botId, landingPageId) {
    return super.delete(`${APIRoutes.LANDING_PAGES(botId)}/${landingPageId}`);
  }
}
